import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

import { CardOrientation } from '../../base/enum'

import ProgressCardDefault from '../default'
import type { ProgressCardProps } from '../types'

const ProgressButton = styled.a`
  background: 0;
  ${focusVisible}
`

const ProgressCard = ({
  product,
  handleClick,
  items,
  orientation = CardOrientation.HORIZONTAL
}: ProgressCardProps) => {
  return (
    <ProgressButton
      data-test='progress-btn'
      onClick={handleClick}
      className='_border-0 _cursor-pointer _w-full _p-0'
      tabIndex={0}>
      <ProgressCardDefault product={product} items={items} orientation={orientation} />
    </ProgressButton>
  )
}

export default ProgressCard
